module.exports = __webpack_public_path__ + "static/media/Strength.0ce49076.png";